import { orbCore } from 'services/Orb/Service'
import { labelList } from './Parser'

export const CommuniquesCategoriesService = {
  listCategories: () => orbCore.communiquesCategoriesDomain.listCategories().then(labelList)
}
